// extracted by mini-css-extract-plugin
module.exports = {"icon":"accountTrigger_icon__clFEX w-[28px] h-[28px] lg_w-[26px] lg_h-[26px] bg-no-repeat bg-contain"};